import { render, staticRenderFns } from "./SettingHome.vue?vue&type=template&id=c36f2f3e&"
import script from "./SettingHome.vue?vue&type=script&lang=js&"
export * from "./SettingHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports